import { render, staticRenderFns } from "./OfferAddCampaign.vue?vue&type=template&id=3327efb0&scoped=true&"
import script from "./OfferAddCampaign.vue?vue&type=script&lang=js&"
export * from "./OfferAddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./OfferAddCampaign.vue?vue&type=style&index=0&id=3327efb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327efb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})
